import { memo } from 'react'
import tw from 'twin.macro'
import { PriorityQueueScreen } from 'src/components/monitoring/PriorityQueueScreen'

const PriorityQueuePageComponent = () => {
  return (
    <div data-testid="dashboard-priority-queue-page" css={tw`h-full`}>
      <PriorityQueueScreen />
    </div>
  )
}

export const PriorityQueuePage = memo(PriorityQueuePageComponent)
